import './styles.scss';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QuestionMark from 'components/QuestionMark';

const propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  questionMark: PropTypes.string
};
const defaultProps = {
  className: ''
};

class ItemTitle extends Component {
  render() {
    const { className, text, questionMark } = this.props;
    return (
      <span className={`item-title ${className}`}>
        {text} {questionMark && <QuestionMark content={questionMark} />}
      </span>
    );
  }
}

ItemTitle.propTypes = propTypes;
ItemTitle.defaultProps = defaultProps;

export default ItemTitle;
